import { combineReducers } from '@reduxjs/toolkit';
import form from 'src/modules/user/form/userFormReducers';
import importerReducer from 'src/modules/user/importer/userImporterReducers';
import list from 'src/modules/user/list/userListReducers';
import view from 'src/modules/user/view/userViewReducers';

// Combine all user-related reducers
const userReducer = combineReducers({
  list,
  form,
  view,
  importer: importerReducer,
});
export default userReducer;

